import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCapIcon, ChevronDownIcon } from 'lucide-react';
import { findDegreesTemplates } from '../data/findDegreesTemplates';
function slugToLabel(slug: string): string {
  return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [isFindDegreesOpen, setIsFindDegreesOpen] = useState(false);
  const scrollToTop = () => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  return <footer className="bg-navy-dark text-white pt-16 pb-8" data-id="element-208" data-mp="3lelzi2xtwhm3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209" data-mp="3le2fmgombj5f">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-210" data-mp="3qcdsz1e4gbse">
          {/* Brand Col */}
          <div className="col-span-1 md:col-span-1" data-id="element-211" data-mp="29y5g5yj5lgty">
            <Link to="/" onClick={scrollToTop} className="flex items-center mb-4" data-id="element-212" data-mp="2a1jhr4jztm0c">
              <GraduationCapIcon className="h-8 w-8 text-gold-light mr-2" data-id="element-213" data-mp="3l8qy89n2utu3" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-214" data-mp="3gapd7j63ckfz">
                Online College Guide
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-215" data-mp="3v919hopjxr6m">
              Empowering students to find the perfect online degree program to
              advance their careers and achieve their goals.
            </p>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-216" data-mp="32w2ztma9cas">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-217" data-mp="33e5v93gaoro">
              Top Programs
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-218" data-mp="huo87csd59ys">
              <li data-id="element-219" data-mp="cus1v6w716g2">
                <Link to="/degrees/business" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-220" data-mp="cu8sieklzqdn">
                  Business Administration
                </Link>
              </li>
              <li data-id="element-221" data-mp="twfmjorqrnps">
                <Link to="/degrees/computer-science" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-222" data-mp="twxrd9sgza9b">
                  Computer Science
                </Link>
              </li>
              <li data-id="element-223" data-mp="18lbuzmxpn2qx">
                <Link to="/degrees/healthcare" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-224" data-mp="18lu0la69itbi">
                  Nursing & Healthcare
                </Link>
              </li>
              <li data-id="element-225" data-mp="1mhpc2uyc124v">
                <Link to="/degrees/psychology" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-226" data-mp="1riv56tvwmrex">
                  Psychology
                </Link>
              </li>
            </ul>

            {/* Find Degrees Dropdown */}
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-3" data-id="element-227" data-mp="2ag5ecolo18fl">
              Find Degrees
            </h3>
            <div className="relative" data-id="element-228" data-mp="25mamuyztjp5y">
              <button type="button" onClick={() => setIsFindDegreesOpen(open => !open)} aria-expanded={isFindDegreesOpen} aria-haspopup="listbox" className="w-full flex items-center justify-between px-3 py-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 rounded-md text-gray-200 transition-colors" data-id="element-229" data-mp="21ma97gkjnhzy">
                <span data-id="element-230" data-mp="2kci97psy5sbx">Select a theme</span>
                <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${isFindDegreesOpen ? 'rotate-180' : ''}`} data-id="element-231" data-mp="2kbgmgo2kjhed" />
              </button>

              {isFindDegreesOpen && <ul role="listbox" className="absolute z-20 left-0 right-0 mt-2 bg-navy-dark border border-white/10 rounded-md shadow-xl overflow-hidden" data-id="element-232" data-mp="13z1in75orir3">
                  {findDegreesTemplates.length === 0 && <li className="px-3 py-2 text-xs text-gray-500 italic" data-id="element-233" data-mp="2wnr3ewc8mx6n">
                      No themes available yet
                    </li>}
                  {findDegreesTemplates.map(template => <li key={template.slug} data-id="element-234" data-mp="3bjqhqopxxtk8">
                      <Link to={`/find-degrees/${template.slug}`} onClick={() => {
                  setIsFindDegreesOpen(false);
                  scrollToTop();
                }} className="block px-3 py-2 text-sm text-gray-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-235" data-mp="3bl1nuv6uzdei">
                        {slugToLabel(template.slug)}
                      </Link>
                    </li>)}
                </ul>}
            </div>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-236" data-mp="1no27nnfumcc4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-237" data-mp="1nnsdroronl15">
              Resources
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-238" data-mp="1wmvzl0i8iejc">
              <li data-id="element-239" data-mp="1wlulen5x9bxe">
                <Link to="/colleges" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-240" data-mp="1wk9quxjlxszj">
                  Partner Colleges
                </Link>
              </li>
            </ul>
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-241" data-mp="zuk0i4i9fxc3">
              Guides
            </h3>
            <ul className="space-y-3" data-id="element-242" data-mp="18wjk94kntfiq">
              <li data-id="element-243" data-mp="18vi8syzqer0h">
                <Link to="/request-information" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-244" data-mp="18uyq3g29byle">
                  Request Information
                </Link>
              </li>
              <li data-id="element-245" data-mp="2gadicejrffuk">
                <Link to="/guide/online-christian-colleges" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-246" data-mp="2g8swddbih58b">
                  Online Christian Colleges
                </Link>
              </li>
              <li data-id="element-247" data-mp="1xbrh8zo8toqn">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-248" data-mp="1xcaw27iljx0g">
                  Financial Aid Guide
                </Link>
              </li>
              <li data-id="element-249" data-mp="27cbii2brit8v">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-250" data-mp="2bbakbe2769w3">
                  Accreditation Info
                </Link>
              </li>
              <li data-id="element-251" data-mp="3msk5c50z59zi">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-252" data-mp="1b347uoy1wkyv">
                  Career Paths
                </Link>
              </li>
              <li data-id="element-253" data-mp="1297pll80bsoq">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-254" data-mp="128pj7vrmry33">
                  Student Success Stories
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Col */}
          <div data-id="element-255" data-mp="jbekqddtp8op">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-256" data-mp="jczew1w86pm1">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-257" data-mp="ef69vc6ns1nc">
              <li data-id="element-258" data-mp="2dqqwpoopkfsk">
                <Link to="/privacy-policy" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-259" data-mp="2dp61dwukkstn">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-260" data-mp="1mld550wkx2pe">
                <Link to="/terms-and-conditions" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-261" data-mp="1mjtp9beu4to5">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-262" data-mp="yv0z5vkw9g1g">
                <Link to="/cookie-policy" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-263" data-mp="yuhisjaw6zpj">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-264" data-mp="tvebstbcqjex">
                <Link to="/do-not-sell-my-info" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-265" data-mp="twz74l5hq6du">
                  Do Not Sell My Info
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8" data-id="element-266" data-mp="ckitjadzcxqa">
          <div className="text-xs text-gray-400 space-y-4 text-center md:text-left" data-id="element-267" data-mp="7ottl5y1tetg">
            <p data-id="element-268" data-mp="mcwwg6gsoae1">
              <strong data-id="element-269" data-mp="mdghvx5nlgwt">Advertiser Disclosure:</strong> OnlineCollegeGuide.com is
              an advertising-supported site. Featured or trusted partner
              programs and all school search, finder, or match results are for
              schools that compensate us. This compensation does not influence
              our school rankings, resource guides, or other
              editorially-independent information published on this site.
            </p>
            <p data-id="element-270" data-mp="10cplzygl4kkf">
              <strong data-id="element-271" data-mp="10c6d178wx6ij">TCPA Disclosure:</strong> By submitting your information
              on this website, you consent to be contacted by our educational
              partners regarding their programs via email, telephone, or text
              message.
            </p>
            <p className="pt-4 text-gray-500" data-id="element-272" data-mp="iu8n2wa8rsyy">
              &copy; {currentYear} OnlineCollegeGuide. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}